
import { Listbox } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { Fragment } from 'react';

const languages = [
    { code: 'fr', label: 'Français', emoji: '🇫🇷', flag: '/icons/flags/fr.svg' },
    { code: 'en', label: 'English', emoji: '🇬🇧', flag: '/icons/flags/en.svg' },
    { code: 'es', label: 'Español', emoji: '🇪🇸', flag: '/icons/flags/es.svg' },
    // { code: 'de', label: 'Deutsch', emoji: '🇩🇪', flag: '/icons/flags/de.svg' },
];

// Composant sélecteur de langue réutilisable
const LanguageSelector = ({ currentLanguage, onChange, mobile = false }) => {
    const selected = languages.find((lang) => lang.code === currentLanguage.split('-')[0]) || languages[0];
    return (
        <select
            value={selected.code}
            onChange={(e) => onChange(e.target.value)}
            className={`${mobile ? 'w-full' : ''
                } bg-light-surface/20 dark:bg-dark-primary/10 text-white border border-light-secondary/30 dark:border-dark-secondary/30 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-light-secondary dark:focus:ring-dark-secondary`}
        >
            {languages.map((lang) => (
                <option className='text-dark-surface bg-light-surface/20 dark:bg-dark-primary/10' key={lang.code} value={lang.code}>
                    {lang.label}
                </option>
            ))}
        </select>
    );
}


const FlagLanguageSelector = ({ currentLanguage, onChange }) => {
    const selected = languages.find(
        (lang) => lang.code === currentLanguage.split('-')[0]
    ) || languages[0];

    return (
        <Listbox value={currentLanguage} onChange={onChange}>
            <div className="relative w-auto">
                <Listbox.Button className="relative flex justify-between w-full py-2 px-1 bg-light-surface/10 dark:bg-dark-surface/10 text-left border border-light-secondary/30 dark:border-dark-secondary/30 rounded-md shadow-sm focus:outline-none focus:ring-2">
                    <span className="flex items-center space-x-2 px-2">
                        <img
                            src={selected.flag}
                            alt={selected.label}
                            className="h-5 w-5 rounded object-cover"
                        />
                        {/* <span className="ml-2 text-light-text dark:text-dark-text">
                            {selected.label}
                        </span> */}
                    </span>
                    <ChevronDownIcon className="h-5 w-5 text-light-text dark:text-dark-text" />
                </Listbox.Button>

                <Listbox.Options className="absolute z-10 mt-1 w-full bg-white dark:bg-dark-surface text-light-text dark:text-dark-text border border-light-secondary/30 dark:border-dark-secondary/30 rounded-md shadow-lg">
                    {languages.map((lang) => (
                        <Listbox.Option key={lang.code} value={lang.code} as={Fragment}>
                            {({ active }) => (
                                <li
                                    className={`cursor-pointer px-4 py-2 flex items-center space-x-2 ${active
                                        ? 'bg-light-secondary/20 dark:bg-dark-secondary/20'
                                        : ''
                                        }`}
                                >
                                    <img
                                        src={lang.flag}
                                        alt={lang.label}
                                        className="h-5 w-5 rounded object-cover"
                                    />
                                    {/* <span className="ml-2">{lang.label}</span> */}
                                </li>
                            )}
                        </Listbox.Option>
                    ))}
                </Listbox.Options>
            </div>
        </Listbox>
    );
};


export {
    LanguageSelector,
    FlagLanguageSelector,
    languages
};
